import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'
import {
  QuestionAnswer,
  QuestionExcludeData,
  QuestionGroup,
  QuestionGroupListResponse,
  QuestionGroupResponse,
  QuestionGroupType,
  QuestionListResponse,
  QuestionPaginatedListResponse,
} from 'src/app/interfaces/question'
import { environment } from 'src/environments/environment'
import { DataBaseService } from '../database/database.service'
import { CustomHttpClient } from '../http/http.service'
import { QuestionExcludeClickData } from './../../interfaces/question'
import { QuizReportUrlType } from './../../interfaces/quiz'

export const QUESTION_TITLE_VALUE_REGEX = /({value_question_)([0-9+]+)(})/

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  constructor(private http: CustomHttpClient, private db: DataBaseService) {}

  selectedQuestionGroup: QuestionGroup | undefined

  private questionGroupSubject = new Subject<QuestionGroup>()
  private questionExcludeClickSubject = new Subject<QuestionExcludeClickData>()
  private questionExcludeSubject = new Subject<QuestionExcludeData>()

  getQuestionGroupSubject(): Observable<QuestionGroup> {
    return this.questionGroupSubject.asObservable()
  }

  getQuestionExcludeClickSubject(): Observable<QuestionExcludeClickData> {
    return this.questionExcludeClickSubject.asObservable()
  }

  getQuestionExcludeSubject(): Observable<QuestionExcludeData> {
    return this.questionExcludeSubject.asObservable()
  }

  excludeClicked(question: QuestionExcludeClickData): void {
    this.questionExcludeClickSubject.next(question)
  }

  excluded(data: QuestionExcludeData): void {
    this.questionExcludeSubject.next(data)
  }

  /** feedback에서 다음 질문 set이 있는 경우 해당 질문 set 가져오기 */
  getNextQuestion(optionId: number): Observable<QuestionListResponse> {
    return this.http.get<QuestionListResponse>(
      `${environment.apiUrl}/v1/question/answer/option/${optionId}/next-question`
    )
  }

  postFeedback(id: number, answers: QuestionAnswer[], type: QuestionGroupType): Observable<void> {
    const body = { target: id, answers }
    const options = { loggingText: `save ${type} feedback` }
    return this.http.post(`${environment.apiUrl}/v1/question/answer/feedback?question_group=${type}`, body, options)
  }

  getQuestionGroupList(type: QuestionGroupType): Observable<QuestionGroupListResponse> {
    return this.http.get<QuestionGroupListResponse>(`${environment.apiUrl}/v1/question-group?type=${type}`)
  }

  selectQuestionGroup(questionGroup: QuestionGroup): void {
    this.selectedQuestionGroup = questionGroup
    this.questionGroupSubject.next(questionGroup)
  }

  getSingleQuestionGroup(type: QuizReportUrlType, id: number): Observable<QuestionGroupResponse> {
    const queryParams = { id }
    return this.http.get<QuestionGroupResponse>(`${environment.apiUrl}/v1/question-group/${type}`, { queryParams })
  }

  getQuestionList(
    type: QuestionGroupType,
    groupId?: number,
    version?: number
  ): Observable<QuestionPaginatedListResponse> {
    let url = `${environment.apiUrl}/v1/question-group/${type}/question`
    const queryParams = { id: groupId ?? null, version: version ?? null }
    return this.http.get<QuestionPaginatedListResponse>(url, { queryParams })
  }

  getGuestQuestionList(quizId: number): Observable<QuestionPaginatedListResponse> {
    const url = `${environment.apiUrl}/v2/question/report/generic/${quizId}/questions`
    return this.http.get<QuestionPaginatedListResponse>(url)
  }

  /**
   * 피드백 질문 가져오기
   */
  feedbackQuestions(type: QuestionGroupType): Observable<QuestionPaginatedListResponse> {
    return this.http.get<QuestionPaginatedListResponse>(`${environment.apiUrl}/v1/question-group/${type}/question`)
  }
}
